import React from 'react';
import { Button, ButtonHandle } from '@progress/kendo-react-buttons';
import { bellIcon } from '@progress/kendo-svg-icons';
import { Badge, BadgeContainer } from '@progress/kendo-react-indicators';
import { NotificationDropdown } from './NotificationDropdown';
import { useNotificationContext } from '@cs-cms/state-management';

export const NotificationBellButton = () => {
  const { centerNotifications, unreadCenterCount, markAllAsRead } = useNotificationContext();
  const [showDropdown, setShowDropdown] = React.useState(false);
  const anchor = React.useRef<ButtonHandle | null>(null);

  const hasUploadInProgress = centerNotifications.some(
    notification =>
      notification.type === 'progress' &&
      notification.progress?.percent !== undefined &&
      notification.progress.percent < 100
  );

  const onDropdownClose = () => {
    setShowDropdown(false);
    markAllAsRead();
  };

  return (
    <>
      <BadgeContainer>
        <div className={`notificationBellWrapper ${hasUploadInProgress ? 'hasUpload' : ''}`}>
          <Button
            ref={anchor}
            svgIcon={bellIcon}
            fillMode="solid"
            className="notificationBellButton"
            onClick={() => setShowDropdown(!showDropdown)}
            size={'medium'}
            themeColor={'primary'}
          />
          {hasUploadInProgress && (
            <div className="uploadProgressIndicator">
              <div className="uploadProgressCircle"></div>
            </div>
          )}
        </div>
        {unreadCenterCount > 0 && <Badge themeColor="error">{unreadCenterCount}</Badge>}
      </BadgeContainer>

      <NotificationDropdown anchorElement={anchor.current} show={showDropdown} onClose={onDropdownClose} />
    </>
  );
};
